import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'pds-text-area',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => TextAreaComponent)
    }
  ]
})
export class TextAreaComponent implements ControlValueAccessor {

  @Input() rows: number;
  @Input() value: string;

  public localValue: string;
  public disabled: boolean;
  public onChange = (_: any) => {};
  public onTouched = () => {};

  constructor() { }

  ngOnChanges(){
    if (this.value) {
      this.localValue = this.value;
    }
  }

  onInput(value: string) {
    this.localValue = value;
    this.onTouched();
    this.onChange(this.value);
  }
  writeValue(value: any): void {
    this.localValue = value || '';
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }
}
